import { useTranslation } from 'next-i18next';

const useInflectedTranslation = () => {
  const { t } = useTranslation('common');
  const getInflectedTranslation = (count: number, word: string) => {
    const rest10 = count % 10;
    const rest100 = count % 100;

    if (count === 1) return t(`${word}.single`);

    if (rest10 >= 2 && rest10 <= 4 && !(rest100 >= 12 && rest100 <= 14)) {
      return t(`${word}.plural`);
    }

    return t(`${word}.genitive`);
  };
  return { getInflectedTranslation };
};

export default useInflectedTranslation;
